var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { ArrowBack, ChevronRightRounded, InsertLinkOutlined } from "@mui/icons-material";
import { Box, Chip, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { v4 } from "uuid";
import { DeleteSvgIcon, DownloadSvgIcon, PrintSvgIcon, ShareLineSvgIcon } from "../../../../../../../assets/customIcons";
import { DynamicFormBuilderContainer } from "../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { ElabelStyling, LOCAL_STORAGE_KEYS } from "../../../../../../../constants";
import { useAppSelector } from "../../../../../../../store/hooks";
import { systemColor } from "../../../../../../../theme/systemColor";
import { getLocalStorageItem } from "../../../../../../../utils/storageHelper";
import { dateFormate, isLoaderActive } from "../../../../../../../utils/utils";
import { getWarehouseListAPICall } from "../../../../../../spareIssue/services/apiCalls";
import { SpareIssuesKeys } from "../../../../../../spareIssue/services/entity";
import { DiscardDocumentModal } from "../../../../../purchaseRequistion/components/DiscardDocumentModal";
import { procurementPriorityListAPICall } from "../../../../../purchaseRequistion/services/apiCall";
import PartDetailsWtoW from "../components/partDetailsWtoW";
import { interWarehouseRequisitionCreateAPICall, interWarehouseRequisitionDeleteAttachmentAPICall, interWarehouseRequisitionGetAPICall, uploadInterWarehouseRequisitionAttachmentAPICall } from "../services/apiCall";
import { EStatusNames, EStocktransferTypes, InterWarehouseReqPartDetailsMandatoryFeilds, InterWarehouseTransferRequisitionKeys } from "../services/entity";
export var CreateInterWarehouseRequisition = function () {
    var _getLocalStorageItem, _getLocalStorageItem2, _getLocalStorageItem3, _crud$InterWarehouseT, _crud$SpareIssuesKeys, _crud$SpareIssuesKeys2, _dateFormate;
    var navigate = useNavigate();
    var searchParams = useSearchParams()[0];
    var _a = useState(""), sourceWarehouse = _a[0], setSourceWarehouse = _a[1];
    var _b = useState(false), openDiscardPopUp = _b[0], setOpenDiscardPopUp = _b[1];
    var _c = useState(""), destinationWarehouse = _c[0], setdestinationWarehouse = _c[1];
    var _d = useState(0), grandTotal = _d[0], setGrandTotal = _d[1];
    var _e = useState(0), totalQuantity = _e[0], setTotalQuantity = _e[1];
    var mode = searchParams.get('mode');
    var UserOrganization = (_getLocalStorageItem = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.data) === null || _getLocalStorageItem === void 0 || (_getLocalStorageItem = _getLocalStorageItem.Branches[0]) === null || _getLocalStorageItem === void 0 ? void 0 : _getLocalStorageItem.OrganizationId;
    var UserParentOrganization = (_getLocalStorageItem2 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.data) === null || _getLocalStorageItem2 === void 0 || (_getLocalStorageItem2 = _getLocalStorageItem2.Branches[0]) === null || _getLocalStorageItem2 === void 0 ? void 0 : _getLocalStorageItem2.ParentOrganizationId;
    var Identity = (_getLocalStorageItem3 = getLocalStorageItem(LOCAL_STORAGE_KEYS.USER_PROFILE_DATA)) === null || _getLocalStorageItem3 === void 0 ? void 0 : _getLocalStorageItem3.data.IdentityId;
    var crud = useAppSelector(function (state) { return state.crud; });
    var data = (_crud$InterWarehouseT = crud[InterWarehouseTransferRequisitionKeys.Get]) === null || _crud$InterWarehouseT === void 0 ? void 0 : _crud$InterWarehouseT.data;
    var id = useParams().id;
    useEffect(function () {
        getWarehouseListAPICall({
            request: {
                TenantId: UserOrganization
            }
        });
    }, []);
    var handleCancelClick = function () {
        setOpenDiscardPopUp(false);
    };
    var handleDiscardClick = function () {
        setOpenDiscardPopUp(false);
        navigate('/interWarehouseTransferRequisition');
    };
    var request = {
        SourceTenantId: UserOrganization,
        SourceParentTenantId: UserParentOrganization,
        DestinationTenantId: UserOrganization,
        DestinationParentTenantId: UserParentOrganization,
        TotalQuantity: totalQuantity,
        TotalDamageQuantity: 0,
        TotalExcessQuantity: 0,
        TotalAmount: grandTotal,
        RecordedBy: Identity,
        Type: EStocktransferTypes.WToWRequisition,
        DocumentDate: new Date().toISOString(),
        ParentId: null,
        Status: EStatusNames.Completed
    };
    var generalTab = [{
            type: FormItemTypes.CardComponent,
            name: "Basic details",
            title: "Basic details",
            elements: [{
                    type: FormItemTypes.SearchSelect,
                    name: 'SourceWarehouseId',
                    label: 'Source Warehouse',
                    disabled: mode !== "add",
                    valueExpr: "id",
                    displayExpr: "Name",
                    options: (_crud$SpareIssuesKeys = crud[SpareIssuesKeys.WarehouseList]) === null || _crud$SpareIssuesKeys === void 0 || (_crud$SpareIssuesKeys = _crud$SpareIssuesKeys.data) === null || _crud$SpareIssuesKeys === void 0 ? void 0 : _crud$SpareIssuesKeys.filter(function (data) { return !((data === null || data === void 0 ? void 0 : data.id) === destinationWarehouse); }),
                    onChange: function (e, value) {
                        setSourceWarehouse(value === null || value === void 0 ? void 0 : value.id);
                    },
                    setFormState: function () { return ({
                        StockTransferRequisitionDetail: [{
                                id: 1
                            }]
                    }); },
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'DestinationWarehouseId',
                    label: 'Destination Warehouse',
                    valueExpr: "id",
                    displayExpr: "Name",
                    disabled: mode !== "add",
                    labelTypographyProps: ElabelStyling,
                    options: (_crud$SpareIssuesKeys2 = crud[SpareIssuesKeys.WarehouseList]) === null || _crud$SpareIssuesKeys2 === void 0 || (_crud$SpareIssuesKeys2 = _crud$SpareIssuesKeys2.data) === null || _crud$SpareIssuesKeys2 === void 0 ? void 0 : _crud$SpareIssuesKeys2.filter(function (data) { return !((data === null || data === void 0 ? void 0 : data.id) === sourceWarehouse); }),
                    onChange: function (e, value) { return setdestinationWarehouse(value === null || value === void 0 ? void 0 : value.id); },
                    required: true
                }, {
                    type: FormItemTypes.SearchSelect,
                    name: 'PriorityId',
                    label: 'Priority',
                    valueExpr: "id",
                    getListData: procurementPriorityListAPICall,
                    displayExpr: "Name"
                }, {
                    type: FormItemTypes.DatePicker,
                    name: 'ExpectedTransferDate',
                    label: 'Expected Transfer Date',
                    disablePast: true
                }, {
                    type: FormItemTypes.NumberInput,
                    name: 'BoxQuantity',
                    label: 'No. of boxes',
                    placeholder: 'Enter'
                }],
            columnSize: 12
        }];
    var additionalTab = [{
            type: FormItemTypes.CardComponent,
            name: 'NotesAndAttachments',
            title: 'Notes and attachments',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: 'Remarks',
                    label: 'Transfer reason/notes(0/200 characters)',
                    placeholder: 'Enter the notes for your IWR to be displayed in your transaction...',
                    md: 6,
                    setFieldProps: function (formValues, value) {
                        var _value$length;
                        return {
                            type: this.type,
                            label: "Priority reason (".concat((_value$length = value === null || value === void 0 ? void 0 : value.length) !== null && _value$length !== void 0 ? _value$length : 0, "/150 characters)")
                        };
                    },
                    maxLength: 200,
                    multiline: true,
                    minRows: 2
                }, {
                    type: FormItemTypes.Attachment,
                    name: 'Attachments',
                    label: 'Add attachments',
                    placeholder: 'Upload Files',
                    value: null,
                    inputProps: {
                        accept: 'application/*',
                        multiple: true
                    },
                    uploadAttachmentRequest: {
                        systemname: InterWarehouseTransferRequisitionKeys.AttachmentSystemName
                    },
                    uploadAttachmentAPI: uploadInterWarehouseRequisitionAttachmentAPICall,
                    deleteAttachmentAPI: interWarehouseRequisitionDeleteAttachmentAPICall
                }]
        }];
    var partDetails = [{
            type: FormItemTypes.Custom,
            name: "StockTransferRequisitionDetail",
            validator: function (values, state) {
                var error = undefined;
                values === null || values === void 0 || values.find(function (r) {
                    var _Object$keys;
                    var errorField = (_Object$keys = Object.keys(InterWarehouseReqPartDetailsMandatoryFeilds)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.find(function (field) { return typeof r[field] !== 'number' && typeof r[field] !== 'boolean' && !r[field]; });
                    if (errorField) {
                        error = {
                            id: v4(),
                            rowId: r.id,
                            field: InterWarehouseReqPartDetailsMandatoryFeilds[errorField],
                            message: 'This field is required',
                            value: r[errorField]
                        };
                    }
                    return Boolean(errorField);
                });
                return error;
            },
            element: PartDetailsWtoW,
            columnSize: 12
        }, {
            type: FormItemTypes.CardComponent,
            name: '',
            columnSize: 12,
            variant: 'outlined',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: 12,
                    justifyContent: 'flex-end',
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'GrandTotal',
                            children: /*#__PURE__*/ React.createElement(Typography, {
                                sx: {
                                    flexGrow: 1
                                },
                                fontWeight: "bold",
                                textAlign: "left"
                            }, "Grand Total"),
                            variant: 'outlined',
                            fullWidth: true,
                            valueGetter: function (formValues, currValue) {
                                var _formValues$StockTran, _formValues$StockTran2;
                                var totalSum = formValues === null || formValues === void 0 || (_formValues$StockTran = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran === void 0 ? void 0 : _formValues$StockTran.reduce(function (acc, data) {
                                    return acc + (data.PurchasePrice * data.RequestedQuantity || 0);
                                }, 0);
                                var totalQty = formValues === null || formValues === void 0 || (_formValues$StockTran2 = formValues.StockTransferRequisitionDetail) === null || _formValues$StockTran2 === void 0 ? void 0 : _formValues$StockTran2.reduce(function (acc, data) {
                                    return acc + data.RequestedQuantity;
                                }, 0);
                                setGrandTotal(totalSum && totalSum);
                                setTotalQuantity(totalQty);
                                return totalSum;
                            },
                            sx: {
                                justifyContent: 'space-between',
                                bgcolor: 'rgba(0,0,0,0.05)',
                                fontWeight: 'bold',
                                color: systemColor.secondary
                            },
                            endIcon: grandTotal ? "".concat(grandTotal.toFixed(2)) : '₹ 00.00',
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: this.type,
                                    startIcon: formValues !== null && formValues !== void 0 && formValues.Open ? /*#__PURE__*/ React.createElement(ChevronRightRounded, null) : /*#__PURE__*/ React.createElement(ChevronRightRounded, null)
                                };
                            },
                            setFormState: function (formValues, e, field) {
                                return {
                                    Open: !(formValues !== null && formValues !== void 0 && formValues.Open)
                                };
                            }
                        }]
                }]
        }];
    var tabs = [{
            id: '0',
            label: 'General Details',
            elements: generalTab
        }, {
            id: '1',
            label: 'Part Details',
            elements: partDetails
        }, {
            id: '2',
            label: 'Additional info',
            elements: additionalTab
        }];
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: 'pageHeader',
            columnSize: 12,
            justifyContent: 'space-between',
            alignItems: 'center',
            spacing: 0,
            columnSpacing: 1,
            gap: 2,
            p: 2,
            elements: [{
                    type: FormItemTypes.IconButton,
                    name: "backArrow",
                    id: "backArrow",
                    columnSize: 0,
                    children: /*#__PURE__*/ React.createElement(ArrowBack, {
                        fontSize: "small",
                        id: 'arrow-back'
                    }),
                    onClick: function () { return navigate('/interWarehouseTransferRequisition'); }
                }, {
                    type: FormItemTypes.Typography,
                    name: 'Header',
                    children: mode == 'edit' ? 'Inter-warehouse requisition' : 'New inter-warehouse requisition',
                    columnSize: 0,
                    variant: 'h1',
                    noWrap: true
                }, mode !== "edit" ? null : {
                    type: FormItemTypes.Custom,
                    name: 'StatusCard',
                    columnSize: 0,
                    element: function () {
                        var _data$Statuses, _data$Statuses2;
                        return (data === null || data === void 0 || (_data$Statuses = data.Statuses) === null || _data$Statuses === void 0 ? void 0 : _data$Statuses.Name) && /*#__PURE__*/ React.createElement(Chip, {
                            label: data === null || data === void 0 || (_data$Statuses2 = data.Statuses) === null || _data$Statuses2 === void 0 ? void 0 : _data$Statuses2.Name,
                            size: "small",
                            variant: "outlined",
                            sx: {
                                borderRadius: 2,
                                px: 1,
                                fontWeight: 'bold'
                            },
                            icon: /*#__PURE__*/ React.createElement(Box, {
                                id: "create-spare-status-box",
                                height: 8,
                                width: 8,
                                borderRadius: 10,
                                bgcolor: "gray"
                            })
                        });
                    }
                }, {
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    xs: 12,
                    sm: true,
                    item: false,
                    justifyContent: {
                        xs: 'space-between',
                        sm: 'flex-end'
                    },
                    spacing: 0,
                    p: {
                        xs: 2,
                        sm: 0
                    },
                    alignItems: 'center',
                    elements: mode !== "edit" ? [] : [{
                            type: FormItemTypes.Typography,
                            name: 'DocumentCode',
                            label: 'IWR NUMBER: ',
                            children: null,
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }, {
                            type: FormItemTypes.Typography,
                            name: 'IWR Date',
                            label: 'IWR DATE: ',
                            value: (_dateFormate = dateFormate(data === null || data === void 0 ? void 0 : data.DocumentDate)) !== null && _dateFormate !== void 0 ? _dateFormate : null,
                            children: null,
                            columnSize: 0,
                            containerProps: {
                                display: {
                                    sm: 'flex'
                                },
                                direction: {
                                    sm: 'row'
                                },
                                spacing: 0,
                                gap: 1,
                                px: 1
                            },
                            fontWeight: 400,
                            fontSize: 14
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: 'ActionPanel',
            columnSize: 12,
            spacing: 0,
            columnSpacing: 2,
            p: 2,
            minWidth: '100%',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignContent: 'flex-end',
            bgcolor: '#EFF2F5',
            setFieldProps: function (formValues, currValue) {
                return {
                    type: this.type,
                    display: {
                        xs: 'none',
                        sm: 'flex'
                    }
                };
            },
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    columnSize: true,
                    item: false,
                    justifyContent: 'end',
                    spacing: 1,
                    elements: [{
                            type: FormItemTypes.Button,
                            name: 'QuickLinks',
                            label: '',
                            value: null,
                            children: 'Quick Links',
                            columnSize: 0,
                            variant: 'text',
                            startIcon: /*#__PURE__*/ React.createElement(InsertLinkOutlined, {
                                id: 'quick-link-icon'
                            }),
                            sx: {
                                background: 'none'
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(DownloadSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(ShareLineSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Button,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(PrintSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary'
                        }, {
                            type: FormItemTypes.Box,
                            name: '',
                            columnSize: 0,
                            height: '100%',
                            width: '2px',
                            bgcolor: 'rgba(0,0,0,0.1)',
                            mx: 1
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Delete',
                            children: /*#__PURE__*/ React.createElement(DeleteSvgIcon, null),
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            onClick: function (e, formValues) {
                                delete formValues.Stepper;
                                delete formValues.Delete;
                                var clone = formValues;
                                var formValueCond = Object.keys(clone).some(function (key) { return clone[key] !== null; });
                                if (formValueCond)
                                    setOpenDiscardPopUp(true);
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'SaveAsDraft',
                            label: '',
                            value: null,
                            children: 'Save as draft',
                            columnSize: 0,
                            variant: 'outlined',
                            color: 'secondary',
                            onClick: function (e, values) { return __awaiter(void 0, void 0, void 0, function () {
                                var res;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, interWarehouseRequisitionCreateAPICall({
                                                request: _objectSpread(_objectSpread(_objectSpread({}, request), values), {}, {
                                                    Status: EStatusNames.Draft
                                                })
                                            })];
                                        case 1:
                                            res = _a.sent();
                                            if (res !== null && res !== void 0 && res.success || (res === null || res === void 0 ? void 0 : res.code) === 200)
                                                navigate("/interWarehouseTransferRequisition");
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }, {
                            type: FormItemTypes.Button,
                            name: 'Save',
                            label: '',
                            value: null,
                            children: 'Save',
                            id: 'save',
                            columnSize: 0,
                            variant: 'contained',
                            onClick: function () { return 'submit'; }
                        }]
                }]
        }, {
            type: FormItemTypes.Tabs,
            name: "Stepper",
            value: "0",
            tabs: tabs,
            valueExpr: "id",
            displayExpr: "label",
            columnSize: 12,
            variant: 'scrollable',
            tabPanelProps: {
                sx: {
                    px: {
                        xs: 2,
                        sm: 2.5,
                        md: 3
                    }
                }
            },
            sx: {
                paddingX: {
                    xs: 2,
                    sm: 2.5,
                    md: 3
                },
                gap: 2.5
            },
            stackContainerProps: {
                sx: {
                    mb: {
                        xs: 7.5,
                        sm: 0
                    }
                }
            }
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, isLoaderActive([InterWarehouseTransferRequisitionKeys.Create, InterWarehouseTransferRequisitionKeys.UOMDetailsByProductId, InterWarehouseTransferRequisitionKeys.LocationDetails, InterWarehouseTransferRequisitionKeys.ProductPrices]), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridSpacing: 0,
        formProps: {
            sx: {
                '& .MuiMobileStepper-root': {
                    display: 'none'
                }
            }
        },
        getFormAPI: interWarehouseRequisitionGetAPICall,
        getKey: InterWarehouseTransferRequisitionKeys.Get,
        getRequest: {
            id: id
        },
        pagingAPIKey: InterWarehouseTransferRequisitionKeys.Paging,
        createFormAPI: interWarehouseRequisitionCreateAPICall,
        createKey: InterWarehouseTransferRequisitionKeys.Create,
        createRequest: request,
        updateFormAPI: interWarehouseRequisitionCreateAPICall,
        updateRequest: _objectSpread(_objectSpread({}, request), {}, {
            StockTransferRequisitionId: id
        }),
        updateKey: InterWarehouseTransferRequisitionKeys.Create,
        onClose: function () { return navigate("/interWarehouseTransferRequisition"); }
    }), openDiscardPopUp && /*#__PURE__*/ React.createElement(DiscardDocumentModal, {
        openPopUp: openDiscardPopUp,
        handleCancelClick: handleCancelClick,
        handleDiscardClick: handleDiscardClick
    }));
};
